
  import {Component, Vue} from "vue-property-decorator";

    @Component({name:'AuditLogStatusColumn'})
    export default class AuditLogStatusColumn extends Vue {

    }
